import { CouponListParams } from './coupons';
import { oliveApi } from '../index';

const url = `/admin/v1/companycoupons`;

const getIssuedCouponListApi = async (params: CouponListParams) => {
  return await oliveApi.GET<CouponListParams, any>(`${url}`, params);
};

const issueCouponApi = async (id: string, companyId: number) => {
  return await oliveApi.POST<{ companyId: number; couponId: string }, any>(
    url,
    {
      couponId: id,
      companyId,
    }
  );
};
export { getIssuedCouponListApi, issueCouponApi };
